import VuexPersistence from 'vuex-persist';
import {
  STORAGE_VUEX_SEARCH_PREF_KEY,
  STORAGE_VUEX_SEARCH_PREF_VERSION,
} from '@motionelements/core/src/app.constants';

export default new VuexPersistence({
  key: STORAGE_VUEX_SEARCH_PREF_KEY,
  storage: window.localStorage,
  reducer: ({ search }) => ({
    hash: `${STORAGE_VUEX_SEARCH_PREF_VERSION}`,
    search: {
      preferences: search.preferences,
    },
    modifiedAt: Math.round(Date.now() / 1000),
  }),
  filter: (mutation) => [
    'search/setPreferences',
    'search/setPerPage',
    'search/setVideoPlayerMuted',
  ].includes(mutation.type),
});
